import React, {useEffect, useState} from 'react';
import {Text} from "../../../index";
import {Tooltip} from "antd";
import {useTranslation} from "react-i18next";
import {UpdateOpenStepsList} from "../../../../redux/actions/tourActions";
import {KEY_LOCAL_STORAGE_DONT_SHOW_TOOLTIP_TRAIN, KEY_LOCAL_STORAGE_DONT_SHOW_tOUR_BLOCK} from "../../helpers";
import {useDispatch, useSelector} from "react-redux";
import {CloseIcon} from "../../../../image";
import {Button} from "../../../Button";

const GetStartedItem = ({handleProfileOpenChange, openPopup}) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const isVisibleTooltipLocal = localStorage.getItem(KEY_LOCAL_STORAGE_DONT_SHOW_TOOLTIP_TRAIN);
    const isShowProfilePopup = useSelector((state) => state.tour.isShowProfilePopup);
    const [isOpen, setIsOpen] = useState(!Boolean(isVisibleTooltipLocal));

    useEffect(() => {
        if (!Boolean(isVisibleTooltipLocal)) {
            setIsOpen(true);
        } else if (!isShowProfilePopup) {
            setIsOpen(false)
        }
    }, [openPopup]);

    const onHandleCloseClick = () => {
        setIsOpen(false);
        localStorage.setItem(KEY_LOCAL_STORAGE_DONT_SHOW_TOOLTIP_TRAIN, true);
    }

    function onHandleClickGetStart() {
        handleProfileOpenChange(false);
        setIsOpen(false);
        dispatch(UpdateOpenStepsList(true));
        localStorage.removeItem(KEY_LOCAL_STORAGE_DONT_SHOW_tOUR_BLOCK);
        window.dispatchEvent(
            new CustomEvent("localstorage-change", {
                detail: {key: KEY_LOCAL_STORAGE_DONT_SHOW_tOUR_BLOCK, value: false}
            })
        );
    }

    return (
        <Tooltip
            destroyOnHidden
            placement="right"
            open={isOpen}
            overlayClassName={"started-item-tooltip"}
            overlayInnerStyle={{padding: '8px 16px'}}
            getPopupContainer={() => document.querySelector('.ant-layout')}
            title={
                <div className="started-item-tooltip__container">
                    <div className="started-item-tooltip__header">
                        <Text size="f16" font="bold">{t('get_started_tooltip_title')}</Text>
                        <CloseIcon onClick={onHandleCloseClick}/>
                    </div>
                    <div className="started-item-tooltip__footer">
                        <Button
                            onClick={onHandleCloseClick}
                            size="xs"
                            text={t('got_it')}
                        />

                    </div>
                </div>
            }
        >
            <Text size="f14" font="book" className="menu-item" onClick={onHandleClickGetStart}>{t('get_started')}</Text>
        </Tooltip>
    );
};

export default GetStartedItem;